/**
 * Resize direction enum for multi-directional resizing
 */
export var ResizeDirection;
(function (ResizeDirection) {
    ResizeDirection["NONE"] = "none";
    ResizeDirection["N"] = "n";
    ResizeDirection["E"] = "e";
    ResizeDirection["S"] = "s";
    ResizeDirection["W"] = "w";
    ResizeDirection["NE"] = "ne";
    ResizeDirection["SE"] = "se";
    ResizeDirection["SW"] = "sw";
    ResizeDirection["NW"] = "nw";
})(ResizeDirection || (ResizeDirection = {}));
/**
 * Default theme values
 */
export const defaultTheme = {
    primaryColor: '#0066cc',
    secondaryColor: '#f5f5f5',
    textColor: '#333333',
    backgroundColor: '#ffffff',
    fontFamily: 'system-ui, -apple-system, sans-serif',
    fontSize: '14px',
    borderRadius: '8px',
};
export { BASE_WIDGET_EVENTS } from './WidgetEvents';
//# sourceMappingURL=index.js.map